import { connect } from 'react-redux';

import { selectUserHasCPEmail, selectActiveVenueId } from 'selectors/general';

import { AVAILABILITY_TYPES } from '../../ManageServices.constants';
import { selectServices } from '../../Services/Services.selectors';
import { goToItem as goToItemAction } from '../../ManageServices.saga';
import { editResource as editResourceAction, deleteResource as deleteResourceAction } from '../Resources.saga';
import { selectResourcesEntity, selectSelectedResource } from '../Resources.selectors';
import { messages } from '../Resources.messages';
import ResourceForm from './ResourceForm';

export const mapStateToProps = state => {
  const venueId = selectActiveVenueId(state);
  const { isLoaded, isLoading } = selectResourcesEntity(state);
  const { id, name, services, recurrence, singleDayExceptions } = selectSelectedResource(state);

  return {
    venueId,
    defaultValues: {
      name,
      recurrence,
      serviceIds: (services || []).map(({ id: serviceId }) => serviceId),
      singleDayExceptions,
    },
    id,
    isLoaded,
    isLoading,
    resourceName: name,
    servicesList: selectServices(state),
    showDeleteButton: !!id && selectUserHasCPEmail(state),
    title: messages.form.editResource,
  };
};

const mapDispatchToProps = {
  editResource: editResourceAction,
  deleteResource: deleteResourceAction,
  goToItem: goToItemAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { id, defaultValues, ...restStateProps } = stateProps;
  const { editResource, deleteResource, goToItem } = dispatchProps;
  const { singleDayExceptions: defaultExceptions = [] } = defaultValues;

  return {
    ...restStateProps,
    defaultValues,
    handleCancel: goToItem.bind(null, id),
    deleteResource: deleteResource.bind(null, id),
    handleSubmit: (formValues, formAsyncFns) => {
      let { singleDayExceptions = [] } = formValues;
      const updatedExceptionIds = singleDayExceptions.map(({ id: exceptionId }) => exceptionId);

      // Detect removed time blocks to decorate them with '_delete: true' flag
      defaultExceptions.forEach(exception => {
        const { id: exceptionId, availability } = exception;
        if (!updatedExceptionIds.includes(exceptionId) && availability === AVAILABILITY_TYPES.UNAVAILABLE) {
          singleDayExceptions = singleDayExceptions.concat({ ...exception, _delete: true });
        }
      });

      editResource({ ...formValues, id, singleDayExceptions }, formAsyncFns);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ResourceForm);
